/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var CheeseIcon = createIcon({
  name: 'CheeseIcon',
  height: 512,
  width: 512,
  svgPath: 'M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default CheeseIcon;